import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Offloading / activity zone.
export const ZONE_NODES: IconNode = [
  [
    'path',
    {
      key: 'zone-0',
      d: 'M5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7Z',
    },
  ],
  [
    'path',
    {
      key: 'zone-1',
      d: 'M19 7C20.1046 7 21 6.10457 21 5C21 3.89543 20.1046 3 19 3C17.8954 3 17 3.89543 17 5C17 6.10457 17.8954 7 19 7Z',
    },
  ],
  [
    'path',
    {
      key: 'zone-2',
      d: 'M5 21C6.10457 21 7 20.1046 7 19C7 17.8954 6.10457 17 5 17C3.89543 17 3 17.8954 3 19C3 20.1046 3.89543 21 5 21Z',
    },
  ],
  [
    'path',
    {
      key: 'zone-3',
      d: 'M19 21C20.1046 21 21 20.1046 21 19C21 17.8954 20.1046 17 19 17C17.8954 17 17 17.8954 17 19C17 20.1046 17.8954 21 19 21Z',
    },
  ],
  [
    'path',
    {
      key: 'zone-4',
      d: 'M7.6001 5H16.4001',
    },
  ],
  [
    'path',
    {
      key: 'zone-5',
      d: 'M7.6001 19H16.4001',
    },
  ],
  [
    'path',
    {
      key: 'zone-6',
      d: 'M5 7.6001V16.4001',
    },
  ],
  [
    'path',
    {
      key: 'zone-7',
      d: 'M19 7.6001V16.4001',
    },
  ],
]

export const ZoneIcon: LucideIcon = createLucideIcon('zone', ZONE_NODES)
